import script from "./V4App.vue?vue&type=script&setup=true&lang=js"
export * from "./V4App.vue?vue&type=script&setup=true&lang=js"

import "./V4App.vue?vue&type=style&index=0&id=1846816b&lang=css"

const __exports__ = script;

export default __exports__